import { Select } from "risa-oasis-ui_v2";

interface DrugTypeSelectorProps {
  drugType: string;
  onDrugTypeChange: (value: string) => void;
}

const drugTypeOptions = [
  { label: "Chemotherapy", value: "Chemotherapy" },
  { label: "Supportive", value: "Supportive" },
  { label: "Regular", value: "Regular" },
];

const DrugTypeSelector = ({
  drugType,
  onDrugTypeChange,
}: DrugTypeSelectorProps) => {
  return (
    <div className="mb-6">
      <Select
        id="drugType"
        options={drugTypeOptions}
        label="Drug Type"
        placeholder="Select Drug Type"
        onOptionChange={(option) => onDrugTypeChange(option.value)}
        defaultValue={drugType}
      />
    </div>
  );
};

export default DrugTypeSelector;
